import React, { useState } from 'react'
import Icon from 'components/Icon'

const Number = ({ onValidate, attribute, interimState, state, onChange }) => {
  const [errors, setErrors] = useState([])
  const { key, name, options, disabled } = attribute

  return (
    <fieldset className="space-y-1">
      <p className="text-xs font-medium text-gray-600 uppercase tracking-wider">
        { name }
      </p>

      <input
        type="number"
        disabled={disabled}
        placeholder={`Enter ${name} here..`}
        value={interimState || state || ''}
        onChange={({ target: { value } }) => onChange(value)}
        onBlur={onValidate}
        className={`w-full p-2 px-3 focus:border-primary transition duration-200 border border-gray-300 ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
      />

      { state && state.length && errors.map((error) => (
        <small className="text-sm font-medium text-blue-500 block">
          { error } <Icon icon="exclamation-circle" />
        </small>
      )) }
    </fieldset>
  )
}

export default Number
